import { getAirports } from '../../../shared/data-services/airport-service';
import { getAbsenteeismSupportConsult } from '../../../shared/data-services/AbsenteeismSupport-Service';
import { Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";

export async function getAllAirports() {
    return await getAirports();
};

export async function getMonthsView(strfechaInicio, strfechaFin) {
    const fechaInicio = new Date(strfechaInicio);
    const fechaFin = new Date(strfechaFin);
    const data = [];

    while (fechaFin >= fechaInicio) {
        const Month = new Intl.DateTimeFormat('es-CO', { month: "long" }).format(new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), 1));
        data.push({
            Year: fechaInicio.getFullYear(),
            Month: Month.charAt(0).toUpperCase() + Month.slice(1)
        });
        fechaInicio.setMonth(fechaInicio.getMonth() + 1);
    }
    return data;
};

export async function getData(params) {
    const data = await getAbsenteeismSupportConsult(params);
    // console.log("data", data);
    return data.map((element, index) => {
        const start = element.startDate ? dayjs(element.startDate) : null;
        const end = element.endDate ? dayjs(element.endDate) : null;
        const dias = start && end ? end.diff(start, 'day') + 1 : 0;

        return {
            id: element.id || index,
            employeeId: element.employeeId,
            employeeName: element.employeeName,
            email: element.email,
            phoneNumber: element.phoneNumber,
            companyId: element.companyId,
            empresa: element.empresa,
            fechaIngreso: element.fechaIngreso || "",
            area: element.area || "",
            cargo: element.cargo,
            centroCosto: element.centroCosto,
            days: dias,
            airportCode: element.airportCode,
            healthEntity: element.healthEntity,
            absenteeismIssuer: element.absenteeismIssuer,
            typeAbsenteeism: element.typeAbsenteeism,
            detailAbsenteeism: element.detailAbsenteeism,
            codeCIE: element.codeCIE || "",
            startDate: element.startDate ? new Date(element.startDate).toISOString().split('T')[0] : "",
            endDate: element.endDate ? new Date(element.endDate).toISOString().split('T')[0] : "",
            observation: element.observation || "",
            active: element.active ? "Activo" : "Inactivo",
            creationUser: element.creationUser,
            creationDate: element.creationDate,
            updateUser: element.updateUser,
            updateDate: element.updateDate
        };
    });
};

export async function getDataExport(params) {
    const data = await getData(params);
    const dataReal = [];

    data.forEach(element => {
        const itemReal = [
            { v: element.employeeId, t: "s" },
            { v: element.employeeName, t: "s" },
            { v: element.empresa || '', t: "s" },
            { v: element.fechaIngreso || '', t: "s" },   // <-- NUEVO
            { v: element.area || '', t: "s" },
            { v: element.cargo || '', t: "s" },
            { v: element.centroCosto || '', t: "s" },
            { v: element.days || '', t: "s" },
            { v: element.airportCode, t: "s" },
            { v: element.healthEntity, t: "s" },
            { v: element.absenteeismIssuer, t: "s" },
            { v: element.typeAbsenteeism, t: "s" },
            { v: element.detailAbsenteeism, t: "s" },
            { v: element.codeCIE || "", t: "s" },
            { v: element.startDate, t: "s" },
            { v: element.endDate, t: "s" },
            { v: element.observation || "", t: "s" },
            { v: element.active, t: "s" },
            { v: element.creationUser, t: "s" },
            { v: element.creationDate ? new Date(element.creationDate).toISOString().split('T')[0] : "", t: "s" },
            { v: element.updateUser, t: "s" },
            { v: element.updateDate ? new Date(element.updateDate).toISOString().split('T')[0] : "", t: "s" }
        ];

        dataReal.push(itemReal);
    });

    return dataReal;
};

const BoldHeader = styled("span")({
    fontWeight: "bold"
});

export async function getColumns(dataShift) {
    return [
        { field: 'id', headerName: 'ID', width: 60, hide: true },
        { field: 'employeeId', headerName: 'Identificación', width: 150, renderHeader: () => <BoldHeader>Identificación</BoldHeader> },
        { field: 'employeeName', headerName: 'Nombre completo', width: 250, renderHeader: () => <BoldHeader>Nombre completo</BoldHeader> },
        { field: 'empresa', headerName: 'Empresa', width: 100, renderHeader: () => <BoldHeader>Empresa</BoldHeader> },
        { field: 'fechaIngreso', headerName: 'Fecha Ingreso', width: 120, renderHeader: () => <BoldHeader>Fecha Ingreso</BoldHeader> },
        { field: 'area', headerName: 'Área', width: 150, renderHeader: () => <BoldHeader>Área</BoldHeader> },
        { field: 'cargo', headerName: 'Cargo', width: 200, renderHeader: () => <BoldHeader>Cargo</BoldHeader> },
        { field: 'centroCosto', headerName: 'Centro Costo', width: 105, renderHeader: () => <BoldHeader>Centro Costo</BoldHeader> },
        { field: 'days', headerName: 'Días', width: 50, align: 'center', renderHeader: () => <BoldHeader>Días</BoldHeader> },
        { field: 'airportCode', headerName: 'Base', width: 70, renderHeader: () => <BoldHeader>Base</BoldHeader> },
        { field: 'healthEntity', headerName: 'Entidad de Salud', width: 250, renderHeader: () => <BoldHeader>Entidad de Salud</BoldHeader> },
        { field: 'absenteeismIssuer', headerName: 'Emisor Ausentismo', width: 150, renderHeader: () => <BoldHeader>Emisor Ausentismo</BoldHeader> },
        { field: 'typeAbsenteeism', headerName: 'Tipo de Ausentismo', width: 200, renderHeader: () => <BoldHeader>Tipo de Ausentismo</BoldHeader> },
        { field: 'detailAbsenteeism', headerName: 'Detalle de Ausentismo', width: 200, renderHeader: () => <BoldHeader>Detalle de Ausentismo</BoldHeader> },
        { field: 'codeCIE', headerName: 'Código CIE', width: 250, renderHeader: () => <BoldHeader>Código CIE</BoldHeader>, renderCell: (params) => <Tooltip title={params.value || ''} arrow><span>{params.value}</span></Tooltip> },
        { field: 'startDate', headerName: 'Fecha Inicio', width: 120, renderHeader: () => <BoldHeader>Fecha Inicio</BoldHeader> },
        { field: 'endDate', headerName: 'Fecha Fin', width: 120, renderHeader: () => <BoldHeader>Fecha Fin</BoldHeader> },
        { field: 'observation', headerName: 'Observación', width: 250, renderHeader: () => <BoldHeader>Observación</BoldHeader> },
        { field: 'active', headerName: 'Estado', width: 100, renderHeader: () => <BoldHeader>Estado</BoldHeader> },
        { field: 'creationUser', headerName: 'Usuario Creación', width: 150, renderHeader: () => <BoldHeader>Usuario Creación</BoldHeader> },
        { field: 'creationDate', headerName: 'Fecha Creación', width: 150, renderHeader: () => <BoldHeader>Fecha Creación</BoldHeader>, valueGetter: (params) => params.value ? dayjs(params.value).format("YYYY-MM-DD HH:mm") : '' },
        { field: 'updateUser', headerName: 'Usuario Actualización', width: 165, renderHeader: () => <BoldHeader>Usuario Actualización</BoldHeader> },
        { field: 'updateDate', headerName: 'Fecha Actualización', width: 150, renderHeader: () => <BoldHeader>Fecha Actualización</BoldHeader>, valueGetter: (params) => params.value ? dayjs(params.value).format("YYYY-MM-DD HH:mm") : '' }
    ];
}
